import * as moment from 'moment';
import { DateRange, IStringDateRange2 } from '../../models/dateRange';

export interface IDateRangeService {
    initialized(value?: boolean): boolean;
    initByState($state: angular.ui.IStateParamsService): IStringDateRange2;
    beginDate(value?: string | Date): string | Date;
    endDate(value?: string | Date): string | Date;
    compare(value?: boolean): boolean;
    comparePeriod(value?: string): string;
    compareRange(value?: DateRange): DateRange;
    getComparisonPeriod(): IStringDateRange2;
    getComparisonDuration(): moment.Duration;
}

export class DateRangeService implements IDateRangeService {
    static serviceId = 'dateRangeService';

    static $inject = [];

    private _beginDate: string | Date;
    private _endDate: string | Date;
    private _compare: boolean;
    private _comparePeriod: string;
    private _dateRange: DateRange;
    private _initialized: boolean;

    constructor() {
        if (!this._beginDate && !this._endDate) {
            const now = moment(new Date());
            this._endDate = now.toISOString();
            this._beginDate = now.add(-1, 'd').toISOString();
            this._initialized = true;
        }
    }

    initialized(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._initialized = value;
        }
        return this._initialized;
    }

    initByState($stateParams: angular.ui.IStateParamsService): IStringDateRange2 {
        const beginDate = $stateParams['beginDate'];
        if (beginDate) {
            this.beginDate(beginDate);
            this.initialized(true);
        }
        const endDate = $stateParams['endDate'];
        if (endDate) {
            this.endDate(endDate);
            this.initialized(true);
        }
        return {
            beginDate: beginDate,
            endDate: endDate
        };
    }

    beginDate(value?: string | Date): string | Date {
        if (arguments.length) {
            this._beginDate = value;
        } else {
            return this._beginDate;
        }
    }

    endDate(value?: string | Date): string | Date {
        if (value) {
            this._endDate = value;
        }
        return this._endDate;
    }

    compare(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._compare = value;
        }
        return this._compare;
    }

    comparePeriod(value?: string): string {
        if (value) {
            this._comparePeriod = value;
        }
        return this._comparePeriod;
    }

    compareRange(value?: DateRange): DateRange {
        if (value) {
            this._dateRange = value;
        }
        return this._dateRange;
    }

    getComparisonPeriod(): IStringDateRange2 {
        let result: IStringDateRange2;
        if (this.comparePeriod() !== 'custom') {
            const period = this.getComparisonDuration();
            result = {
                beginDate: moment(this.beginDate()).subtract(period).toISOString(),
                endDate: moment(this.endDate()).subtract(period).toISOString()
            };
        } else {
            result = {
                beginDate: this._dateRange.beginDateTime,
                endDate: this._dateRange.endDateTime
            };
        }
        return result;
    }

    getComparisonDuration() {
        let result: moment.Duration = null;
        switch (this.comparePeriod()) {
        case 'previousPeriod':
            result = moment.duration(moment(this.endDate()).diff(moment(this.beginDate())));
            break;
        case 'previousMonth':
            result = moment.duration(1, 'M');
            break;
        case 'previousYear':
            result = moment.duration(1, 'y');
            break;
        case 'custom':
            result = moment.duration(moment(this.beginDate()).diff(moment(this.compareRange().beginDateTime)));
            break;
        default:
            throw new Error('Invalid comparison period');
        }
        return result;
    }
}